import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { CATEGORIES } from "@/lib/siteData";

export const Categories = () => {
  return (
    <section
      id="categories"
      data-testid="categories-section"
      className="relative bg-[#1a1a1a] py-20 md:py-28"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 mb-12 md:mb-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-[2px] bg-[#c41e3a]" />
              <span className="font-mono-upper text-[11px] text-[#c41e3a]">
                Markets We Serve
              </span>
            </div>
            <h2 className="font-display font-black text-white text-4xl md:text-6xl leading-[1] tracking-[-0.03em] max-w-2xl">
              Three sectors.
              <span className="block text-[#c41e3a]">Zero compromises.</span>
            </h2>
          </div>
          <p className="font-body text-white/65 text-base md:text-lg max-w-sm leading-relaxed">
            Different buildings demand different systems. We specialize in all three.
          </p>
        </div>
      </div>

      {/* 3 columns */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-y border-white/10">
        {CATEGORIES.map((c, idx) => (
          <motion.a
            key={c.title}
            href="#contact"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: idx * 0.1 }}
            data-testid={`category-card-${idx}`}
            className="group relative block h-[460px] md:h-[560px] overflow-hidden border-b md:border-b-0 md:border-r border-white/10 last:border-r-0"
          >
            {/* Image */}
            <img
              src={c.image}
              alt={c.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/50 to-[#1a1a1a]/95 group-hover:from-black/20 group-hover:via-[#c41e3a]/20 group-hover:to-[#1a1a1a]/95 transition-all duration-500" />

            {/* Top index */}
            <div className="relative z-10 p-7 md:p-9 flex items-start justify-between">
              <span className="font-mono-upper text-[11px] text-white/60">
                0{idx + 1} / 03
              </span>
              <span className="font-mono-upper text-[11px] text-[#c41e3a]">
                {c.tag}
              </span>
            </div>

            {/* Bottom content */}
            <div className="absolute inset-x-0 bottom-0 z-10 p-7 md:p-9">
              <h3 className="font-display font-black text-white text-4xl md:text-5xl tracking-[-0.02em] leading-none">
                {c.title}
              </h3>
              <p className="font-body text-white/75 text-base mt-4 max-w-xs leading-relaxed">
                {c.copy}
              </p>
              <div className="mt-6 flex items-center gap-3 text-white font-mono-upper text-[11px] group-hover:text-[#c41e3a] transition-colors">
                Learn More
                <ArrowRight
                  size={14}
                  weight="bold"
                  className="transition-transform group-hover:translate-x-1"
                />
              </div>
            </div>

            {/* Left red accent */}
            <span className="absolute left-0 top-0 bottom-0 w-0 bg-[#c41e3a] group-hover:w-[4px] transition-all duration-500 z-10" />
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default Categories;
